import { Injectable } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { HttpClient} from '@angular/common/http';
import { Activities } from 'src/interfaces/activities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppservicesService {

  offlineUrl="http://192.168.2.250:8300/api/";
  onlineUrl="https://naledi-appstore-api.herokuapp.com/api/";

  constructor(private http:HttpClient,private toastCtrl:ToastController, private modalCtrl:ModalController) { }

  async presentToast(msg:string,colorsent:string=''){
    const toast= await this.toastCtrl.create({
      mode:'ios',
      position:'bottom',
      color:`${colorsent}`,
      buttons:[
        {text:'Annuler'}
      ],
      message:msg,
      duration:2000
    });
    toast.present();
  }

  async closemodal(){
    this.modalCtrl.dismiss();
  }

  getlistapps(){
    let items=[
      {id:1,name:'REFLET',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400},
      {id:2,name:'DUKA',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400},
      {id:3,name:'OHADA',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400},
      {id:4,name:'PONYA',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400},
      {id:5,name:'RUHUSA',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400},
      {id:6,name:'RIHYU',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400},
      {id:7,name:'REFLET TOOL KIT',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400},
      {id:8,name:'PONYA 2',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/applog.jpg',default_price:400},
      {id:9,name:'REFLET 2',description:'Reflet est une application de vente des services et produits',category_id:1,category_name:'Applications',avatar:'assets/images/appimage.jpg',default_price:400}
    ];

    return items;
  }

  dashboardData(){
    let items=[
      {rowdata:{objects:[
        {title:'EMPLOYES',background:'justify-center bg-transparency-2 ion-padding',iconbackground:'justify-center bg-transparency-2 ',subtitle:'9',righticon:'people',footerdata:[
          {titlef:'Act.',dataf:99,type:'number',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'},
          {titlef:'Inact.',dataf:99,type:'number',color:'light',class:'bg-danger padding-3 radius-5 text-05'}
        ]},
        {title:'MAISONS',background:'justify-center bg-home ion-padding',iconbackground:'justify-center bg-transparency-2 ',subtitle:'2',righticon:'home',footerdata:[
          {titlef:'Appli.',dataf:9,type:'number',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'}
        ]},
        {title:'APPLICATIONS',background:'justify-center bg-softs ion-padding',iconbackground:'justify-center bg-transparency-2 ',subtitle:'3',righticon:'apps',footerdata:[
          {titlef:'Act.',dataf:99,type:'number',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'},
          {titlef:'Inact.',dataf:99,type:'number',color:'light',class:'bg-danger padding-3 radius-5 text-05'}
        ]},
        {title:'FACTURES',background:'justify-center bg-invoices ion-padding ',iconbackground:'justify-center bg-transparency-2 ',subtitle:'4',righticon:'cash',footerdata:[
          {titlef:'Pay.',dataf:9,type:'number',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'},
          {titlef:'Impay.',dataf:0,type:'number',color:'light',class:'bg-danger padding-3 radius-5 text-05'}
        ]}
      ]}
    },
    {
      rowdata:{objects:[
        {title:'SMS',background:'justify-center bg-sms ion-padding',iconbackground:'justify-center bg-transparency-2 ',subtitle:'4000',righticon:'chatbubble-ellipses',footerdata:[
          {titlef:'Env.',dataf:9,type:'number',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'},
          {titlef:'Solde',dataf:0,type:'number',color:'light',class:'bg-danger padding-3 radius-5 text-05'}
        ]},
        {title:'NOTIFICATIONS',background:'justify-center bg-notifications ion-padding',iconbackground:'justify-center bg-transparency-2 ',subtitle:'+99',righticon:'notifications',footerdata:[
          {titlef:'Lues',dataf:99,type:'number',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'},
          {titlef:'N. lues',dataf:99,type:'number',color:'light',class:'bg-danger padding-3 radius-5 text-05'}
        ]},
        {title:'CONFIGURATIONS',background:'justify-center bg-settings ion-padding',iconbackground:'justify-center bg-transparency-2 ',subtitle:'Achevée',righticon:'settings',footerdata:[
          {titlef:'Parfaite',dataf:'60%',type:'text',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'}
        ]},
        {title:'BACKUPS',background:'justify-center bg-backups ion-padding',iconbackground:'justify-center bg-transparency-2 ',subtitle:'9',righticon:'cloud-download',footerdata:[
          {titlef:'Téléchargement',dataf:99,type:'number',color:'light',class:'bg-tertiary padding-3 radius-5 text-05 mrg-right-10'}
        ]}
      ]}
    }
    ];

    return items;
  }

  companyiesdata(){
    let items=[
      {id:1,name:'NALEDI SERVICES',description:'Naledi softs et autres',status:'enabled',logo:'assets/images/applog.jpg',owner_id:20220819000},
      {id:2,name:'NALEDI MARKET',description:'Ventes et livraison a domicile',status:'desabled',logo:'assets/images/applog.jpg',owner_id:20220819001},
      {id:3,name:'ITOT AFRICA',description:'Mises a niveau professionnelles',status:'desabled',logo:'assets/images/applog.jpg',owner_id:20220819000},
      {id:4,name:'GO INNOVATION',description:'Formations professionnelles',status:'desabled',logo:'assets/images/applog.jpg',owner_id:20220819000},
      {id:5,name:'EREST',description:'Lavages a sec',status:'enabled',logo:'assets/images/applog.jpg',owner_id:20220819000},
      {id:6,name:'BUREC',description:'Parti politique',status:'desabled',logo:'assets/images/applog.jpg',owner_id:20220819000},
      {id:7,name:'KIVU MARCHE',description:'Ventes des produits',status:'desabled',logo:'assets/images/applog.jpg',owner_id:20220819000},
      {id:8,name:'Pharmacie Docs',description:'Ventes produits pharmaceutiques',status:'desabled',logo:'assets/images/applog.jpg',owner_id:20220819000},
  ];
  return items;
  }

  getactivities(){
    
    let items=[
      {id:1,name:'Restaurant',description:'description',tags:['resto','bar','autres']},
      {id:2,name:'Stock',description:'gestock',tags:['stock','gestock','approv','gestion']},
      {id:3,name:'Finance',description:'finance',tags:['finance','fin','financier','financiere']},
      {id:4,name:'Lavage',description:'lavage',tags:['lavage','laver','kufula','wash','repassage']},
      {id:5,name:'Garage',description:'garage',tags:['garage','vehicule','reparer']}
    ];
   
    return items;

    //return this.http.get<Activities[]>(this.offlineUrl+'/activity');
  }


}
